import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=10b623fd"
import script from "./Dropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dropdown.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports